module.exports = __webpack_public_path__ + "img/banner2_upload.1e73eb47.svg";